<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers /></el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">
								Edit Change Request
							</div>
				
							<div v-if="infoData" class="page_main">
								<div class="change-request-page">
				
									<div class="btn_el">
										<div class="tips">
											You may update the change request description and justification, identify all affected documents, and specify all impacts resulting from the proposed change.
										</div>
									</div>
				
									<el-form ref="form" :model="infoData" label-position="top" class="request-form">
				
										<div class="form-grid">
				
											<!-- Left -->
											<div class="form-col">
												<el-form-item label="Request ID">
													<el-input v-model="infoData.request_id" readonly class="gray-input">
														<template slot="prepend"></template>
													</el-input>
												</el-form-item>
				
												<el-form-item label="Requester">
													<el-input v-model="infoData.username" readonly class="gray-input"></el-input>
												</el-form-item>
				
												<el-form-item v-if="infoData.status_name" label="Status">
													<el-input v-model="infoData.status_name" readonly class="gray-input"></el-input>
												</el-form-item>
											</div>
				
											<!-- Right -->
											<div class="form-col">
												<el-form-item label="Change Request Creation Date">
													<el-input v-model="infoData.dateline" readonly class="gray-input"></el-input>
												</el-form-item>
											</div>
				
										</div>
				
										<div class="btn_el">
											<div class="tips">
												Please verify that the summary description and justification of the change request are complete. If not, update them accordingly.
											</div>
										</div>
				
										<el-form-item label="Change Request Summary" required>
											<el-input
												v-model="infoData.overall_description"
												type="textarea"
												:rows="7"
												resize="none"
											/>
										</el-form-item>
				
										<el-form-item label="Justification / Rationale" required>
											<el-input
												v-model="infoData.reason"
												type="textarea"
												:rows="7"
												resize="none"
											/>
										</el-form-item>
				
									</el-form>
				
									<div class="divider" />
				
									<div class="btn_el">
										<div class="tips">
											Identify all documents included in this change request, including new documents for release, existing documents to be revised or obsoleted, and obsolete documents to be restored.
										</div>
									</div>
				
									<!-- Table -->
									<div class="table-card">
				
										<div class="table-card-header">
											<div class="table-title">
												Documents Included in the Change Request
											</div>
										</div>
				
										<el-table
											v-if="infoData.versioninfo"
											:data="tableData"
											border
											stripe
											header-cell-class-name="custom-table-header"
											cell-class-name="custom-table-cell"
											class="document-table"
										>
				
											<el-table-column
												width="100"
												label="Actions"
												fixed="left"
											>
												<template slot-scope="scope">
													<el-button
														type="primary"
														@click="handleEdit(scope.row)"
													>
														Edit
													</el-button>
												</template>
											</el-table-column>
				
											<el-table-column
												prop="ref"
												label="Document Number"
												min-width="140"
												sortable
											/>
				
											<el-table-column
												prop=""
												label="Current Revision"
												min-width="130"
												sortable
											>
												<template slot-scope="scope">
													{{ scope.row.old_vnumber || 'N/A' }}
												</template>
											</el-table-column>
				
											<el-table-column
												prop="vnumber"
												label="New Revision"
												min-width="130"
												sortable
											/>
				
											<el-table-column
												prop="vname"
												label="Document Name"
												min-width="160"
												sortable
											/>
				
											<el-table-column
												prop="leixing_name"
												label="Document Type"
												min-width="130"
												sortable
											/>
				
											<el-table-column
												prop="vdesc"
												label="Change Description"
												min-width="200"
												sortable
											/>
				
											<el-table-column
												label="Actions"
												width="100"
												fixed="right"
											>
												<template slot-scope="scope">
													<el-button
														type="danger"
														@click="handleDel(scope.row)"
													>
														Delete
													</el-button>
												</template>
											</el-table-column>
				
										</el-table>
				
										<div class="table-btns">
											<el-button
												:disabled="tableData.length > 0"
												type="primary"
												@click="handleCreate"
											>
												Create New Document
											</el-button>
				
											<el-button
												:disabled="tableData.length > 0"
												type="primary"
												@click="handleCurrentEdit"
											>
												Use Existing Document
											</el-button>
				
											<el-button
												:disabled="tableData.length > 0"
												type="primary"
												@click="handleCurrentInvalid"
											>
												Obsolete Existing Document
											</el-button>
				
											<el-button
												:disabled="tableData.length > 0"
												type="primary"
												@click="handleRestoreInvalid"
											>
												Restore Obsolete Document
											</el-button>
										</div>
				
									</div>
				
									<div class="divider" />
				
									<div class="footer-actions">
				
										<el-button
											type="primary"
											@click="handleSaveBack"
										>
											Save for Later
										</el-button>
				
										<el-button
											v-if="infoData.step == 1"
											:disabled="tableData.length == 0"
											type="primary"
											@click="handleSaveContinue"
										>
											Save and Continue to Sign
										</el-button>
				
										<el-button
											v-if="infoData.step == 1"
											type="primary"
											@click="handleWithdraw"
										>
											Withdraw
										</el-button>
				
										<el-button
											v-if="infoData.step == 2"
											type="primary"
											@click="handlePass2"
										>
											Approve
										</el-button>
				
										<el-button
											v-if="infoData.step == 2"
											type="danger"
											@click="handleNoPass2"
										>
											Reject
										</el-button>
				
										<el-button
											type="primary"
											@click="handleCancel"
										>
											Cancel
										</el-button>
				
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--签名弹框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
			<div class="save_box">
				<div class="form_box">
					<div style="padding-bottom: 20px; font-weight: bold; font-size: 16px;">
						Please complete the following information.
					</div>
		
					<el-form
						:model="ruleForm"
						:rules="rules"
						ref="ruleForm"
						label-width="0px"
					>
						<div class="input_el">
							<div class="tit required">
								Comments
							</div>
		
							<el-form-item label="" prop="remark">
								<el-input
									type="textarea"
									:rows="3"
									v-model="ruleForm.remark"
									placeholder="Please enter your comments."
									clearable
								/>
							</el-form-item>
						</div>
		
						<div class="input_el">
							<div class="tit required">
								Password
							</div>
		
							<el-form-item label="" prop="signature">
								<el-input
									v-model="ruleForm.signature"
									placeholder="Please enter your password."
									clearable
									show-password
								/>
							</el-form-item>
						</div>
					</el-form>
				</div>
		
				<div class="btn_box">
					<van-button
						class="btn_el"
						type="default"
						round
						@click="dialogVisible = false"
					>
						Cancel
					</van-button>
		
					<van-button
						class="btn_el"
						round
						color="linear-gradient(to right, #7BC1FF, #4886FF)"
						@click="submitForm('ruleForm')"
					>
						Sign
					</van-button>
				</div>
			</div>
		</el-dialog>
		<!--签名弹框-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import {
	resourcesApplyDetail,
	resourcesDel,
	resourcesSubmit,
	resourcesApplyHandle
} from '@/api/docManage/changeRequest/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from 'js-md5';
export default {
	components: {
		headers,
		slider,
	},
	data() {
		return {
			isLoading: true,
			keyword: "",
			infoData: null,
			tableData: [],
			dialogVisible: false,
			dialogTitle: '',
			passStatus: null,
			ruleForm: {
				remark: '',
				signature: ''
			},
			rules: {
				remark: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				signature: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				]
			},
		};
	},
	created() {
		let that = this;
	},
	mounted() {
		let that = this;
		//请求请求详情
		resourcesApplyDetail({ id: that.$route.query.oid }).then(res => {
			if(res.code == 200) {
				that.infoData = res.data;
				if(that.infoData.versioninfo) {
					that.tableData.push(that.infoData.versioninfo);
				}
			}
			that.isLoading = false;
		});
	},
	watch: {
		//
	},
	computed: {},
	methods: {
		//创建新文档
		handleCreate() {
			let that = this;
			that.$router.push({ path: '/DocControl/changeRequestAddEditFile', query: { id: that.infoData.id } });
		},
		//使用现有文档
		handleCurrentEdit() {
			let that = this;
			that.$router.push({ path: '/DocControl/documentsSearch', query: { flag: that.infoData.id, statusSelected: 3, type: 2 } });
			// that.goUrl("/DocControl/changeRequestAddExistFlie");
		},
		//废弃现有文档
		handleCurrentInvalid() {
			let that = this;that.$router.push({ path: '/DocControl/documentsSearch', query: { flag: that.infoData.id, statusSelected: 3, type: 3 } });
			// that.goUrl("/DocControl/changeRequestAbandonFile");
		},
		//恢复过时文档
		handleRestoreInvalid() {
			let that = this;that.$router.push({ path: '/DocControl/documentsSearch', query: { flag: that.infoData.id, statusSelected: 5, type: 4 } });
			// that.goUrl("/DocControl/changeRequestrecoveryFile");
		},
		//保存稍后
		handleSaveBack() {
			let that = this;
			if(that.infoData.overall_description && that.infoData.reason) {
				that.$toast.loading({ duration: 0, forbidClick: true });
				//提交文档变更审批
				resourcesSubmit({
					flow_type: 'resources_update',
					overall_description: that.infoData.overall_description,
					reason: that.infoData.reason,
					id: that.infoData.id
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							that.$router.back();
						}, 800);
					}
				});
			}else {
				that.$toast('Please complete the summary description and reason/justification for the change first.');
			}
		},
		//保存&签名（stpe: 1）
		handleSaveContinue() {
			let that = this;
			if(that.infoData.overall_description && that.infoData.reason) {
				that.dialogTitle = 'Save and continue signing';
				that.dialogVisible = true;
			}else {
				that.$toast('Please complete the summary description and reason/justification for the change first.');
			}
		},
		//签名确认
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					if(that.infoData.step == 1) {
						//第一步
						that.$toast.loading({ duration: 0, forbidClick: true });
						//保存（提交文档变更审批）
						resourcesSubmit({
							flow_type: 'resources_update',
							overall_description: that.infoData.overall_description,
							reason: that.infoData.reason,
							id: that.infoData.id
						}).then(res => {
							if(res.code == 200) {
								//签名（审批）
								resourcesApplyHandle({
									id: that.$route.query.oid,
									remark: that.ruleForm.remark,
									signature: md5(that.ruleForm.signature+'AiisoQms2026'),
									status: 2
								}).then(res2 => {
									if(res2.code == 200) {
										that.$toast.clear();
										that.dialogVisible = false;
										that.$message.success('Operation successful');
										setTimeout(() => {
											that.$router.back();
										}, 800);
									}
								});
							}
						});
					}else if(that.infoData.step == 2){
						//第二步
						//签名（审批）
						resourcesApplyHandle({
							id: that.$route.query.oid,
							remark: that.ruleForm.remark,
							signature: md5(that.ruleForm.signature+'AiisoQms2026'),
							status: that.passStatus
						}).then(res2 => {
							if(res2.code == 200) {
								that.$toast.clear();
								that.dialogVisible = false;
								that.$message.success('Operation successful');
								setTimeout(() => {
									that.$router.back();
								}, 800);
							}
						});
					}
				}else {
					return false;
				}
			});
		},
		//通过（step: 2）
		handlePass2() {
			let that = this;
			that.$confirm("Confirm request approved?", "Confirmation", {
				type: "warning",
			}).then(() => {
				that.passStatus = 2;
				that.dialogTitle = 'Request approved';
				that.dialogVisible = true;
			}).catch(() => {});
		},
		//拒绝（step: 2）
		handleNoPass2() {
			let that = this;
			that.$confirm("Confirm request rejected?", "Confirmation", {
				type: "warning",
			}).then(() => {
				that.passStatus = 3;
				that.dialogTitle = 'Reject request';
				that.dialogVisible = true;
			}).catch(() => {});
		},
		//编辑文件
		handleEdit(row) {
			let that = this;
			switch(row.operation) {
				case 1:
					that.$router.push({ path: '/DocControl/changeRequestAddEditFile', query: { id: that.infoData.id, vid: row.vid } });
				break;
				case 2:
					that.$router.push({ path: '/DocControl/changeRequestAddExistFlie', query: { oid: that.infoData.id, old_vid: row.vid, type: 'edit' } });
				break;
				case 3:
					that.$router.push({ path: '/DocControl/changeRequestAbandonFile', query: { oid: that.infoData.id, old_vid: row.vid, type: 'edit' } });
				break;
				case 4:
					that.$router.push({ path: '/DocControl/changeRequestrecoveryFile', query: { oid: that.infoData.id, old_vid: row.vid, type: 'edit' } });
				break;
			}
		},
		//删除文件
		handleDel(value) {
			let that = this;
			that.$confirm("Confirm deletion of this file?", "Confirmation", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				//删除文件
				resourcesDel({ vid: value.vid }).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation successful');
						setTimeout(() => {
							window.location.reload();
						}, 800);
					}
				});
			}).catch(() => {});
		},
		//撤回
		handleWithdraw() {
			let that = this;
			that.$router.push({ path: '/DocControl/changeRequestWithdraw', query: { oid: that.$route.query.oid } });
		},
		//取消
		handleCancel() {
			this.$router.back();
		},
		//跳转页面
		goUrl(url) {
			let that = this;
			that.$router.push(url);
		},
	},
};
</script>

<style lang="less" scoped>
//保存签名
.save_box{
	.btn_box{
		text-align: right;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
	.form_box{
		.input_el{
			.tit{
				padding-bottom: 5px;
				font-size: 14px;
				color: #333333;
			}
			.required::before {
				content: '*';
				color: red;
				margin-right: 2px;
			}
		}
	}
}
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}
::v-deep .btn span {
  text-decoration: underline;
}
.change-request-page {
  border-radius: 4px;
  color: #333;
  font-size: 14px;
  line-height: 22px;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label 样式 */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

/* 输入框统一风格 */
.gray-input ::v-deep .el-input__inner {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.gray-input ::v-deep .el-input__inner[readonly] {
  cursor: default;
}

.divider {
  height: 1px;
  background: #dcdfe6;
  margin: 24px 0;
}

.table-card {
  margin-top: 16px;
  border: 1px solid #d8dde3;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
}

.table-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 14px 10px;
  background: #f5f6f7;
  border-bottom: 1px solid #d8dde3;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.table-tools {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-input {
  width: 230px;
}

.search-input ::v-deep .el-input__inner {
  border-radius: 8px;
  border: 1px solid #cfd5db;
  height: 40px;
  line-height: 40px;
}

.collapse-btn {
  width: 40px;
  height: 40px;
  padding: 0;
  border-radius: 8px;
}

.document-table {
  width: 100%;
}

.document-table ::v-deep .custom-table-header {
  background: #f4f6f8;
  color: #2f343b;
  font-weight: 700;
  font-size: 14px;
  border-bottom: 2px solid #3c4043;
}

.document-table ::v-deep .custom-table-cell {
  color: #2f343b;
  font-size: 14px;
}

.document-table ::v-deep .el-table__cell {
  padding: 12px 8px;
}

.document-table ::v-deep .cell {
  word-break: break-word;
  line-height: 1.5;
}

.table-btns {
  padding: 18px 0 10px 4px;
}

.footer-actions {
  margin-top: 26px;
  display: flex;
  justify-content: center;
  gap: 14px;
}
</style>

